import React from "react";
import { RuleTypeEnum } from "../../Enum";
import RuleTypeSelector from "../RuleTypeSelector/RuleTypeSelector";
import ComparisonRuleForm from "../ComparisonRuleForm/ComparisonRuleForm";
import ValidationRuleForm from "../ValidationRuleForm/ValidationRuleForm";
import CausalityRuleForm from "../CausalityRuleForm/CausalityRuleForm";
import HistoricalRuleForm from "../HistoricalRuleForm/HistoricalRuleForm";
import { manResponseType } from "../../interfaces";

type AllRulesFormProps = {
  ruleType: RuleTypeEnum;
  setRuleType: React.Dispatch<React.SetStateAction<RuleTypeEnum>>;
  onComparisonSubmit: (data: any) => void;
  onValidationSubmit: (data: any) => void;
  onCausalitySubmit: (data: any) => void;
  onHistoricalSubmit: (data: any) => void;
  manifestNames: Record<string, string>;
  responseDescriptions: manResponseType[];
  idManResponseAvailable: number[];
};

const AllRulesForm: React.FC<AllRulesFormProps> = ({
  ruleType,
  setRuleType,
  onComparisonSubmit,
  onValidationSubmit,
  onCausalitySubmit,
  onHistoricalSubmit,
  manifestNames, 
  responseDescriptions,
  idManResponseAvailable,
}) => {
  const forms = {
    [RuleTypeEnum.Comparison]: (
      <ComparisonRuleForm
        onSubmit={onComparisonSubmit}
        manifestNames={manifestNames}
      />
    ),
    [RuleTypeEnum.Validation]: (
      <ValidationRuleForm
        onSubmit={onValidationSubmit}
        manifestNames={manifestNames}
        responseDescriptions={responseDescriptions}
        idManResponseAvailable={idManResponseAvailable}
      />
    ),
    [RuleTypeEnum.Causality]: (
      <CausalityRuleForm
        onSubmit={onCausalitySubmit}
        manifestNames={manifestNames}
        responseDescriptions={responseDescriptions}
        idManResponseAvailable={idManResponseAvailable}
      />
    ),
    [RuleTypeEnum.Historical]: (
      <HistoricalRuleForm
        onSubmit={onHistoricalSubmit}
        manifestNames={manifestNames}
      />
    ),
  };

  return (
    <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-8">
      <RuleTypeSelector selectedType={ruleType} onSelect={setRuleType} />
      {forms[ruleType]}
    </div>
  );
};

export default AllRulesForm;
